import { UPDATE_PLACE } from '../../constants/actions/policy';

export function updatePlace(payload) {
    return {
        type: UPDATE_PLACE,
        payload,
    };
}
